/** @format */

import React, { useRef, useState } from 'react';
import style from '../css/HeaderForm.module.css';
import Select, { components } from 'react-select';

// import emailjs from '@emailjs/browser';
// import Swal from 'sweetalert2';
// import ReCAPTCHA from 'react-google-recaptcha';

// import { SiZoom, SiWhatsapp } from 'react-icons/si';
import { MdPlayArrow } from 'react-icons/md';

import paises, { paises2, cursos } from '../utils/paises';
import profile, { software, inversion } from '../utils/options';

import VideoModal from './modals/VideoModal';

import personaje from '../images/headerForm.png';
import logo from '../images/logo_dot.png';

const HeaderForm = () => {
	const captcha = useRef(null);
	const [openModal, setOpenModal] = useState(false);
	const [formularioEnviado, setFormularioEnviado] = useState(false);

	// expresiones regulares para validar campos
	const regexNombre = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;
	const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const regexCelular = /^\+[1-9]\d{1,3}[ \t\-]?(?:\d[ \t\-]?){6,14}$/;

	const [errores, setErrores] = useState({
		Last_Name: '',
		Email: '',
		Phone: '',
	});

	const [templateParams, setTemplateParams] = useState({
		Last_Name: '',
		// LASTNAME: '',
		Email: '',
		Country: '',
		Phone: '',
		LEADCF14: '', //Profile
		LEADCF13: [{}], //Software
		LEADCF5: '', //PC
		LEADCF4: '', //Area
		LEADCF21: '', //Inversion
	});

	// const serviceID = 'service_t4ltjhw';
	// const templateID = 'template_nekhiqv';
	// const publicKey = 'DCgvpZvEmo1MaZGx-';

	const handlerClose = () => {
		setOpenModal(false);
	};

	const handlerSubmit = (event) => {
		event.preventDefault();
		if (formularioEnviado) {
			return;
		}
		setFormularioEnviado(true);

		// emailjs
		// 	.send(serviceID, templateID, templateParams, publicKey)
		// 	.then((res) => {
		// 		console.log('Datos enviados correctamente', res);
		// 		setTemplateParams({
		// 			FIRSTNAME: '',
		// 			// LASTNAME: '',
		// 			CONTACT_EMAIL: '',
		// 			COUNTRY: '',
		// 			CONTACT_CF16: '',
		// 			PHONE: '',
		// 			CONTACT_CF3: '',
		// 		});
		// 		Swal.fire({
		// 			title: '¡Enviado!',
		// 			text: 'Tus datos se han envíado satisfactoriamente',
		// 			icon: 'success',
		// 			confirmButtonText: 'Aceptar',
		// 		});
		// 	})
		// 	.catch((err) =>
		// 		Swal.fire({
		// 			title: 'Error',
		// 			text: 'Error al envíar los datos',
		// 			icon: 'error',
		// 			confirmButtonText: 'Aceptar',
		// 		})
		// 	);

		// if (form.querySelector('#zc_spmSubmit')) {
		// 	form.querySelector('#zc_spmSubmit').remove();
		// }
		// form.submit();

		// setTemplateParams({
		// 	FIRSTNAME: '',
		// 	// LASTNAME: '',
		// 	CONTACT_EMAIL: '',
		// 	COUNTRY: '',
		// 	CONTACT_CF16: '',
		// 	PHONE: '',
		// 	CONTACT_CF3: '',
		// });

		setTimeout(() => {
			setFormularioEnviado(false);
		}, 2000);
	};

	const validarCampo = (name, value) => {
		let mensajeError = '';

		// if (!value.trim()) {
		// 	mensajeError = 'Este campo es obligatorio.';
		// 	return mensajeError;
		// }

		if (name === 'Last_Name') {
			if (value.length > 0 && !regexNombre.test(value.trim())) {
				mensajeError = 'El nombre no debe contener números ni caracteres especiales.';
			}
		}

		if (name === 'Email') {
			if (value.length > 5 && !regexEmail.test(value.trim())) {
				mensajeError = 'El formato del correo no es válido.';
			}
		}

		if (name === 'Phone') {
			if (value.length > 3 && !regexCelular.test(value.trim())) {
				mensajeError = 'El formato del celular es inválido.';
			}
		}

		return mensajeError;
	};

	const handlerChange = (event) => {
		const nameProp = event.target.name;
		let valueProp = event.target.value;
		setTemplateParams({ ...templateParams, [nameProp]: valueProp });

		const errorActualizado = validarCampo(nameProp, valueProp);

		setErrores({
			...errores,
			[nameProp]: errorActualizado,
		});
	};

	const handlerChangeId = (e) => {
		const idProp = e.target.id;
		let valueProp = e.target.value;
		setTemplateParams({ ...templateParams, [idProp]: valueProp });
		const errorActualizado = validarCampo(idProp, valueProp);

		setErrores({
			...errores,
			[idProp]: errorActualizado,
		});
	};

	const handlerCountrySelect = (event) => {
		const valueProp = event.target.value;
		const paisActual = paises.find((e) => e.nombre === valueProp);

		if (paisActual) {
			setTemplateParams({
				...templateParams,
				Country: paisActual.nombre,
				Phone: paisActual.ind,
			});
		}
	};

	const handlerCountrySelect2 = (event) => {
		const name = event.label;
		const ind = event.ind;

		setTemplateParams({
			...templateParams,
			Country: name,
			Phone: ind,
		});
	};

	// function handlerReCAPTCHA(value) {
	// 	console.log('usuario verificado');
	// }

	const IconOption = (props) => {
		return (
			<components.Option {...props}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={props.data.img}
						alt={`Bandera de ${props.data.label}`}
						style={{
							width: '25px',
							height: 'auto',
							marginRight: '10px',
							borderRadius: '2px',
							objectFit: 'cover',
						}}
					/>
					<span style={{ fontSize: '14px', color: '#333' }}>
						<span style={{ color: '#888', marginLeft: '5px' }}>{props.data.value}</span>
					</span>
				</div>
			</components.Option>
		);
	};

	const SingleValue = (props) => {
		return (
			<components.SingleValue {...props}>
				<div value={props.data.label} style={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={props.data.img}
						alt={`Bandera de ${props.data.label}`}
						style={{
							width: '20px',
							height: 'auto',
							marginRight: '8px',
							borderRadius: '2px',
							objectFit: 'cover',
						}}
					/>
					<span style={{ fontSize: '14px', fontWeight: '500' }}>{props.data.value}</span>
				</div>
			</components.SingleValue>
		);
	};

	return (
		<section className={style.header} id='home'>
			<div className={style.containerMain}>
				<div className={style.headerContainer}>
					<div className={style.headerContent}>
						<div className={style.burbuja}>
							<div>
								<img src={logo} alt='logo-libel' />
							</div>
							<h3>
								<b> Certificación</b> Universitaria
							</h3>
						</div>
						<h1 className={style.headerTitle}>
							CLASES ONLINE
							<br />
							100% en{' '}
							<span>
								VIVO
								{/* <img
									src='https://react-bitakon.netlify.app/assets/img/icon/slider-stoke-shape.svg'
									alt='line'
									className={style.headerLine}
								/> */}
							</span>
						</h1>

						<p>
							Inicia hoy tu entrenamiento online en vivo desde cualquier parte del mundo, te
							llevamos de cero a niveles avanzados.
						</p>
						<div className={style.headerButtons}>
							<a
								// className='header-button degrade'
								className={`${style.headerButton} ${style.degrade}`}
								href='https://api.whatsapp.com/send?phone=573105868543&text=%F0%9F%94%A5Hola%20Libel%F0%9F%91%8D%2C%20deseo%20informaci%C3%B3n%20de%20los%20entrenamientos%E2%9C%8B'
								// target={'_blank'}
								// rel='noreferrer'
							>
								{/* <SiWhatsapp style={{ fontSize: 20, marginRight: 10 }} /> */}
								Más información
							</a>
							{/* <a
								className={style.headerButton2}
								onClick={() => setOpenModal(true)}
								// href='https://libel.academy/asesoria/'
								// target={'_blank'}
								rel='noreferrer'
							>
								<div className={style.buttonPlay}>
									<MdPlayArrow style={{ fontSize: 28, marginLeft: 2 }} />
								</div>
								Ver video
							</a> */}
						</div>
					</div>
				</div>

				{/* <div className={style.imgPersonajeContainer}>
					<img src={personaje} alt='personaje zbrush' />
				</div> */}

				<div className={style.containerForm} id='form'>
					<h1>
						Inicia tu proceso de <span>admisión</span>
					</h1>
					<h2>Nuestro equipo evaluará tu perfil</h2>
					<form
						id='webform4793673000069018003'
						action='https://crm.zoho.com/crm/WebToLeadForm'
						name='WebToLeads4793673000069018003'
						method='POST'
						acceptCharset='UTF-8'
					>
						<input
							type='text'
							style={{ display: 'none' }}
							name='xnQsjsdp'
							value='987fed0bb7f8eae91cc5a5366f952191e8ba243d3f462a75e412779906b5e3bd'
						></input>
						<input type='hidden' name='zc_gad' id='zc_gad' value=''></input>
						<input
							type='text'
							style={{ display: 'none' }}
							name='xmIwtLD'
							value='432f47ca9b5ca3fb52c870a742c92ef02cbabb05376b97f094aed98f4f95fd01aeb1dfec8f8123ef24aa716d2832facb'
						></input>
						<input
							type='text'
							style={{ display: 'none' }}
							name='actionType'
							value='TGVhZHM='
						></input>
						<input
							type='text'
							style={{ display: 'none' }}
							name='returnURL'
							value='https&#x3a;&#x2f;&#x2f;www.libel.academy&#x2f;morco'
						></input>
						{/* ------------------------------------------------------- */}
						<div className={style.orderForm}>
							<div className={style.containerInputMain}>
								<div className={style.titleInput}>
									<label htmlFor='Last_Name'>
										Nombre Completo<span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<input
										onChange={handlerChangeId}
										type='text'
										id='Last_Name'
										name='Last Name'
										placeholder='Tu nombre completo'
										autoComplete='off'
										maxLength='30'
										required
									></input>
								</div>
								{errores.Last_Name ? <p className={style.error}>{errores.Last_Name}</p> : null}
							</div>

							<div className={style.containerInputMain}>
								<div className={style.titleInput}>
									<label htmlFor='Email'>
										Correo electrónico<span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<input
										onChange={handlerChange}
										value={templateParams.Email}
										type='email'
										// ftype='email'
										id='Email'
										autoComplete='off'
										placeholder='ejemplo@correo.com'
										name='Email'
										crmlabel=''
										maxLength='100'
										required
									></input>
								</div>
								{errores.Email ? <p className={style.error}>{errores.Email}</p> : null}
							</div>
						</div>
						<div className={style.orderForm}>
							<div className={style.containerInputMainCounty} style={{ zIndex: '3' }}>
								<div className={style.titleInput} style={{ zIndex: '4' }}>
									<label htmlFor='Country'>
										País<span style={{ color: 'red' }}>*</span>
									</label>
								</div>

								<Select
									styles={{
										control: (baseStyles, state) => ({
											...baseStyles,
											backgroundColor: state.isFocused ? '#05092b' : 'trasnparent',
											borderRadius: '10px',
											border:
												state.isFocused || state.hasValue ? '1px solid #6000de' : '1px solid white',

											boxShadow: 'none',
											'&:hover': {
												border: 'auto',
											},
											cursor: 'pointer',
											transition: 'all 0.3s ease-in-out',
											minHeight: '50px',
										}),
										placeholder: (styles, state) => ({
											...styles,
											fontSize: '12px',
											fontFamily: 'Be Vietnam Pro',
											color: '#9e9e9e',
											paddingLeft: '9px',
											// margin: '0px',
											// padding: '0',
										}),

										valueContainer: (base, state) => {
											const hasValue = state.selectProps.value?.length > 1;
											return {
												...base,
												padding: '0 15px', // Alineación del texto interno
												paddingTop: hasValue ? '12px' : '0px',
											};
										},
										singleValue: (base) => ({
											...base,
											color: 'white',
										}),
										multiValue: (base) => ({
											...base,
											backgroundColor: '#ffffff20', // Fondo de las etiquetas seleccionadas
											borderRadius: '4px',
										}),
										multiValueLabel: (base) => ({
											...base,
											color: 'white',
										}),
										multiValueRemove: (base) => ({
											...base,
											color: 'white',
											'&:hover': {
												backgroundColor: 'red',
												color: 'white',
											},
										}),
										indicatorSeparator: () => ({
											display: 'none', // Quita la línea vertical al lado de la flecha
										}),
										menu: (base) => ({
											...base,
											backgroundColor: '#05092b', // Color de fondo de la lista desplegable
										}),
										option: (base, state) => ({
											...base,
											backgroundColor: state.isFocused ? '#ffffff20' : 'transparent',
											color: 'white',
										}),
										dropdownIndicator: (base, state) => ({
											...base,
											color: state.isFocused ? '#6000de' : 'white', // Morado si está activo
											transition: 'all 0.3s ease-in-out',
										}),
									}}
									onChange={handlerCountrySelect2}
									// id='Country'
									// name='Country'
									// value={templateParams.Country}
									options={paises2}
									required
									components={{
										Option: IconOption, // Reemplazamos el componente Option
										SingleValue: SingleValue, // Reemplazamos el componente SingleValue
									}}
									placeholder='Elige'
								/>
							</div>
							<input type='hidden' name='Country' id='Country' value={templateParams.Country} />

							<div className={style.containerInputMain} style={{ maxWidth: '206px' }}>
								<div className={style.titleInput}>
									<label htmlFor='Phone'>
										Celular<span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<input
										type='text'
										id='Phone'
										name='Phone'
										placeholder='+00 0000000000'
										onChange={handlerChange}
										value={templateParams.Phone}
										autoComplete='off'
										maxLength='20'
										required
									></input>
								</div>
								{errores.Phone ? <p className={style.error}>{errores.Phone}</p> : null}
							</div>

							<div className={style.containerInputMain}>
								<div className={style.titleInput}>
									<label htmlFor='LEADCF14'>
										Perfil profesional<span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<select
										className={templateParams.LEADCF14 ? style.selected : style.noSelected}
										onChange={handlerChange}
										value={templateParams.LEADCF14 ? templateParams.LEADCF14 : ''}
										id='LEADCF14'
										name='LEADCF14'
										type='text'
										required
									>
										<option hidden={true} value=''>
											Selecciona tu perfil
										</option>

										{profile.map((profile, i) => (
											<option key={i} value={profile}>
												{profile}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>
						<div className={style.orderForm}>
							<div className={style.containerInputMainMulti}>
								<div className={style.titleInputMulti}>
									<label htmlFor='LEADCF13'>
										Software que utilizas<span style={{ color: 'red' }}>*</span>
									</label>
								</div>

								<Select
									styles={{
										control: (baseStyles, state) => ({
											...baseStyles,
											backgroundColor: state.isFocused ? '#05092b' : 'trasnparent',
											borderRadius: '10px',
											border: state.isFocused ? '1px solid #6000de' : '1px solid white',

											boxShadow: 'none',
											'&:hover': {
												border: 'auto',
											},
											cursor: 'pointer',
											transition: 'all 0.3s ease-in-out',
											minHeight: '50px',
										}),
										placeholder: (styles, state) => ({
											...styles,
											fontSize: '12px',
											fontFamily: 'Be Vietnam Pro',
											color: '#9e9e9e',
											paddingLeft: '9px',
										}),

										valueContainer: (base, state) => {
											const hasValue = state.selectProps.value?.length > 1;
											return {
												...base,
												padding: '0 15px', // Alineación del texto interno
												paddingTop: hasValue ? '12px' : '0px',
											};
										},
										singleValue: (base) => ({
											...base,
											color: 'white',
										}),
										multiValue: (base) => ({
											...base,
											backgroundColor: '#ffffff20', // Fondo de las etiquetas seleccionadas
											borderRadius: '4px',
										}),
										multiValueLabel: (base) => ({
											...base,
											color: 'white',
										}),
										multiValueRemove: (base) => ({
											...base,
											color: 'white',
											'&:hover': {
												backgroundColor: 'red',
												color: 'white',
											},
										}),
										indicatorSeparator: () => ({
											display: 'none', // Quita la línea vertical al lado de la flecha
										}),
										menu: (base) => ({
											...base,
											backgroundColor: '#05092b', // Color de fondo de la lista desplegable
										}),
										option: (base, state) => ({
											...base,
											backgroundColor: state.isFocused ? '#ffffff20' : 'transparent',
											color: 'white',
										}),
										dropdownIndicator: (base, state) => ({
											...base,
											color: state.isFocused ? '#6000de' : 'white', // Morado si está activo
											transition: 'all 0.3s ease-in-out',
										}),
									}}
									isMulti
									id='LEADCF13'
									name='LEADCF13'
									options={software}
									placeholder='Selecciona los software'
									required
								/>
							</div>

							<div className={style.containerInputMain}>
								<div className={style.titleInput}>
									<label htmlFor='LEADCF21'>
										Perfil de inversión <span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<select
										className={templateParams.LEADCF21 ? style.selected : style.noSelected}
										onChange={handlerChange}
										value={templateParams.LEADCF21 ? templateParams.LEADCF21 : ''}
										id='LEADCF21'
										name='LEADCF21'
										type='text'
										required
									>
										<option hidden={true} value=''>
											Selecciona tu rango de inversión
										</option>

										{inversion.map((e, i) => (
											<option key={i} value={e}>
												{e}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>
						<div className={style.orderForm}>
							<div className={style.containerTextAreaMain}>
								<div className={style.titleTextArea}>
									<label htmlFor='LEADCF5'>
										Caracteristicas de tu equipo <span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.textAreaContainer}>
									<textarea
										id='LEADCF5'
										name='LEADCF5'
										placeholder='Procesador, RAM, Tarjeta de video'
										required
										maxLength='255'
									></textarea>
								</div>
							</div>

							<div className={style.containerTextAreaMain}>
								<div className={style.titleTextArea}>
									<label htmlFor='LEADCF4'>
										Área de especialización <span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.textAreaContainer}>
									<textarea
										id='LEADCF4'
										name='LEADCF4'
										placeholder='Objetivo profesional'
										required
										maxLength='255'
									></textarea>
								</div>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='Lead_Source'>Fuente de Posible cliente</label>
							</div>
							<div class='zcwf_col_fld'>
								<select class='zcwf_col_fld_slt' id='Lead_Source' name='Lead Source'>
									<option value='-None-'>-None-</option>
									<option value='WhatsApp'>WhatsApp</option>
									<option value='Facebook'>Facebook</option>
									<option value='Instagram'>Instagram</option>
									<option value='Calendly'>Calendly</option>
									<option value='Formulario&#x20;web&#x20;home'>Formulario web home</option>
									<option selected value='Formulario&#x20;web&#x20;m&aacute;ster'>
										Formulario web m&aacute;ster
									</option>
									<option value='Correo'>Correo</option>
									<option value='Importaci&oacute;n'>Importaci&oacute;n</option>
									<option value='Feria&#x20;del&#x20;Libro'>Feria del Libro</option>
									<option value='Curso&#x20;gratuito'>Curso gratuito</option>
									<option value='Evento&#x20;Presencial&#x20;24&#x20;agosto'>
										Evento Presencial 24 agosto
									</option>
								</select>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='LEADCF10'>Asesor</label>
							</div>
							<div class='zcwf_col_fld'>
								<select class='zcwf_col_fld_slt' id='LEADCF10' name='LEADCF10'>
									<option value='-None-'>-None-</option>
									<option value='Gilberto'>Gilberto</option>
									<option value='Juieth'>Juieth</option>
									<option value='Katherine'>Katherine</option>
									<option value='Natalia'>Natalia</option>
									<option value='Sonia'>Sonia</option>
									<option value='Viviana'>Viviana</option>
									<option selected value='Otro'>
										Otro
									</option>
								</select>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='LEADCF12'>Formulario de Ads</label>
							</div>
							<div class='zcwf_col_fld'>
								<input
									type='text'
									id='LEADCF12'
									name='LEADCF12'
									maxlength='255'
									value='M&aacute;ster&#x20;en&#x20;ZBrush&#x20;Personaje&#x20;para&#x20;cine'
								></input>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<div className={style.reCaptchaContainer}>
								<label className={style.checkBox}>
									<input type='checkbox' id='cbox1' value='first_checkbox' required /> Acepto
									las&nbsp;
									<a href='https://libel.academy/politicas-de-privacidad/' target={'_blank'}>
										políticas de privacidad
									</a>
								</label>
							</div>
							<input
								className={formularioEnviado ? style.buttonSubmitDisable : style.buttonSubmit}
								disabled={formularioEnviado}
								type='submit'
								id='formsubmit'
								value='Enviar Solicitud'
								title='Enviar'
							/>

							{/* <input
								type='reset'
								class='zcwf_button'
								name='reset'
								value='Restablecer'
								title='Restablecer'
							/> */}
						</div>
						<script
							id='wf_anal'
							src='https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=cef2bd2d87743441117ce925a79765a812cd912dfacf16b82cac5a9df886130c08a5138403e27b4ca41a354d15e88cb0gidf8eca932838edbcb4ff46c4af30b6e8d9f7c91ac377f15cbdd3df45afdb89fbcgid587dc3eb526de219833b06851bc1e36e2d4deb87863cfa2018b74b3238938a3fgid3300670d3ee4732783fab54e8b6f932864177e3e8b10c9f26e52084215ec10dc&tw=f56d14583d1f3fcb5abdf9c4c09f43343d02b73c32b9ae02be2c70db609359a8'
						></script>
					</form>
				</div>
			</div>
			<VideoModal
				modal={openModal}
				url='https://youtu.be/4M4LZ3xt-RA'
				handlerClose={handlerClose}
			/>
		</section>
	);
};

export default HeaderForm;
